
import Editor from "./editor";
import { Component, Vue } from "vue-property-decorator";
import { translit } from "@/cms-services/helpers";
@Component({
  mixins: [Editor],
})
export default class StringEditor extends Vue {
  model: any;
  value: any;
  config: any;
  generateSystemName() {
    const bindedFieldName = this.config?.bindedFieldName ?? "caption";
    const caption = this.model?.[bindedFieldName];
    if (!caption) return;
    this.value = translit(caption);
  }
}
